import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import {
  CloseIconLargeProps,
  NavAngleUpIconProps,
} from './nav-icon-atoms.types';
import { IconProps } from './icon-atoms.types';

const GlobeIcon: React.FC<IconProps> = ({
  className,
  fill = 'none',
  width = 40,
  height = 40,
  viewBox = '0 0 40 40',
  stroke = vars.coreDarkGrey,
  strokeWidth = '0.5',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.4002 15.484H28.8343L28.6165 15.1086C27.4292 13.0618 25.5369 11.4847 23.2607 10.7053L22.6557 10.4982L22.9598 11.0607C23.6725 12.3793 24.2142 13.807 24.6016 15.297L24.6502 15.484H24.8435H28.4002ZM20.2622 10.3108L20.057 10.0158L19.8518 10.3108C18.8301 11.779 18.0347 13.4127 17.5145 15.1628L17.419 15.484H17.7541H22.3598H22.6949L22.5995 15.1628C22.0793 13.4127 21.2838 11.779 20.2622 10.3108ZM10.483 22.5305L10.5313 22.7181H10.7251H14.8002H15.0848L15.0482 22.4359C14.9467 21.6539 14.8815 20.8632 14.8815 20.0567C14.8815 19.2502 14.9467 18.4591 15.0424 17.6757L15.0766 17.3954H14.7942H10.7251H10.5313L10.483 17.583C10.2793 18.373 10.1616 19.2018 10.1616 20.0567C10.1616 20.9117 10.2793 21.7405 10.483 22.5305ZM11.7077 24.6294H11.2737L11.4914 25.0049C12.6785 27.0513 14.5707 28.6347 16.8473 29.4142L17.4506 29.6208L17.1484 29.0592C16.4355 27.7343 15.8938 26.3064 15.5064 24.8165L15.4577 24.6294H15.2644H11.7077ZM15.2644 15.484H15.4577L15.5064 15.297C15.8938 13.807 16.4355 12.3792 17.1484 11.0543L17.4506 10.4927L16.8473 10.6993C14.5707 11.4788 12.6785 13.0621 11.4914 15.1086L11.2737 15.484H11.7077H15.2644ZM19.8514 29.8021L20.057 30.0994L20.2626 29.8021C21.2779 28.3342 22.0731 26.701 22.5992 24.9514L22.6961 24.6294H22.3598H17.7541H17.4179L17.5147 24.9514C18.0408 26.701 18.8361 28.3342 19.8514 29.8021ZM22.8783 22.7181H23.0946L23.1257 22.504C23.2413 21.7068 23.3212 20.8923 23.3212 20.0567C23.3212 19.2211 23.2413 18.4067 23.1257 17.6095L23.0946 17.3954H22.8783H17.2357H17.0194L16.9883 17.6095C16.8727 18.4067 16.7928 19.2211 16.7928 20.0567C16.7928 20.8923 16.8727 21.7068 16.9883 22.504L17.0194 22.7181H17.2357H22.8783ZM22.9656 29.0532L22.663 29.6154L23.2669 29.4081C25.5371 28.6287 27.4291 27.0516 28.6222 25.0054L28.8414 24.6294H28.4063H24.8495H24.6562L24.6076 24.8165C24.2203 26.3062 23.6786 27.7281 22.9656 29.0532ZM25.0656 22.4378L25.0313 22.7181H25.3137H29.3829H29.5751L29.6245 22.5323C29.8347 21.7411 29.9524 20.9117 29.9524 20.0567C29.9524 19.2006 29.8283 18.3717 29.625 17.583L29.5766 17.3954H29.3829H25.3137H25.0292L25.0658 17.6776C25.1673 18.4596 25.2325 19.2503 25.2325 20.0567C25.2325 20.8623 25.1614 21.6529 25.0656 22.4378ZM8.25024 20.0567C8.25024 13.5333 13.5278 8.25 20.051 8.25C26.5744 8.25 31.8637 13.5336 31.8637 20.0567C31.8637 26.5799 26.5744 31.8635 20.051 31.8635C13.5278 31.8635 8.25024 26.5802 8.25024 20.0567Z"
      fill={fill}
      stroke="none"
      strokeWidth={strokeWidth}
    />
  </svg>
);

export const GlobeIconAtom = styled(GlobeIcon)``;

export const CloseIcon: React.FC<IconProps> = ({
  className,
  fill = vars.coreDarkGrey,
  width = 10,
  height = 10,
  viewBox = '0 0 10 10',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L3.58579 5L0.292893 8.29289C-0.0976311 8.68342 -0.0976311 9.31658 0.292893 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L5 6.41421L8.29289 9.70711C8.68342 10.0976 9.31658 10.0976 9.70711 9.70711C10.0976 9.31658 10.0976 8.68342 9.70711 8.29289L6.41421 5L9.70711 1.70711C10.0976 1.31658 10.0976 0.683417 9.70711 0.292893C9.31658 -0.0976311 8.68342 -0.0976311 8.29289 0.292893L5 3.58579L1.70711 0.292893Z"
      fill={fill}
    />
  </svg>
);

export const MobileCloseIcon: React.FC<IconProps> = ({
  fill = vars.coreDarkGrey,
  width = 20,
  height = 18,
  viewBox = '0 0 20 18',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.095 0.870954C18.7168 0.389939 18.0343 0.331894 17.5707 0.741305L0.839578 15.5168C0.375976 15.9262 0.306786 16.648 0.685037 17.129C1.06329 17.6101 1.74574 17.6681 2.20935 17.2587L18.9405 2.48321C19.4041 2.0738 19.4733 1.35197 19.095 0.870954Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.901542 0.870954C1.27979 0.389939 1.96225 0.331894 2.42585 0.741305L19.157 15.5168C19.6206 15.9262 19.6898 16.648 19.3115 17.129C18.9333 17.6101 18.2508 17.6681 17.7872 17.2587L1.05608 2.48321C0.592481 2.0738 0.523291 1.35197 0.901542 0.870954Z"
      fill={fill}
    />
  </svg>
);

export const CloseIconAtom = styled(CloseIcon)``;

export const CloseIconLarge: React.FC<CloseIconLargeProps> = ({
  className,
  width = '25',
  height = '25',
  fill = vars.coreDarkGrey,
  viewBox = '0 0 25 25',
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    onClick={onClick}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7415 2.33869C22.3158 1.73742 21.5477 1.66487 21.026 2.17663L2.19602 20.646C1.67426 21.1578 1.59639 22.06 2.02209 22.6613C2.44779 23.2626 3.21586 23.3351 3.73761 22.8234L22.5676 4.35402C23.0893 3.84225 23.1672 2.93996 22.7415 2.33869Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.26338 2.33869C2.68908 1.73742 3.45715 1.66487 3.9789 2.17663L22.8089 20.646C23.3306 21.1577 23.4085 22.06 22.9828 22.6613C22.5571 23.2626 21.789 23.3351 21.2673 22.8234L2.43731 4.35402C1.91555 3.84225 1.83768 2.93996 2.26338 2.33869Z"
      fill={fill}
    />
  </svg>
);

export const CloseIconLargeAtom = styled(CloseIconLarge)``;

const NavAngleUpIcon: React.FC<NavAngleUpIconProps> = ({
  isHighlighted,
  className,
  width = 16,
  height = 9,
  fill = vars.coreDarkGrey,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5059 9L8 0L0.494141 9H15.5059Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.494141 9L7.99969 0L15.5052 9H14.2031L7.99969 1.56137L1.79624 9H0.494141Z"
      fill={fill}
    />
  </svg>
);

export const NavAngleUpIconAtom = styled(NavAngleUpIcon)`
  position: absolute;
  right: ${vars.standardContentPadding};
  z-index: 100;
  margin-top: 6.3rem;
  pointer-events: none;
  transition: margin-right 0.4s ease;
  display: ${({ isHighlighted }) =>
    isHighlighted === 'topics' || isHighlighted === 'resources'
      ? 'block'
      : 'none'};
  margin-right: ${({ isHighlighted }) =>
    isHighlighted === 'topics'
      ? vars.topicsMarginTenColumn
      : 'resources'
      ? vars.resourcesMarginTenColum
      : null};
  @media screen and (min-width: ${vars.breakPointTwelveColumn}) {
    margin-right: ${({ isHighlighted }) =>
      isHighlighted === 'topics'
        ? vars.topicsMarginTwelveColumn
        : 'resources'
        ? vars.resourcesMarginTwelveColum
        : null};
  }
`;

const WingsIcon: React.FC<IconProps> = ({
  className,
  width = 17,
  height = 11,
  fill = vars.coreDarkGrey,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 4H1.5V2H12.5C13.6046 2 14.5 2.89543 14.5 4Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 7H1.5V5H8.5C9.60457 5 10.5 5.89543 10.5 7Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 10H1.5V8H5.5C6.60457 8 7.5 8.89543 7.5 10Z"
      fill={fill}
    />
  </svg>
);

export const WingsIconAtom = styled(WingsIcon)``;

const SearchIcon: React.FC<IconProps> = ({
  className,
  fill = vars.coreDarkGrey,
  width = 36,
  height = 36,
  viewBox = '0 0 36 36',
  title,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>{title}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.5658C8 10.3873 11.3873 7 15.5658 7C19.7442 7 23.1315 10.3873 23.1315 14.5658C23.1315 18.7442 19.7442 22.1315 15.5658 22.1315C11.3873 22.1315 8 18.7442 8 14.5658ZM15.5658 5C10.2827 5 6 9.28274 6 14.5658C6 19.8488 10.2827 24.1315 15.5658 24.1315C17.5052 24.1315 19.3099 23.5543 20.8173 22.5624C20.8207 22.5665 20.8241 22.5705 20.8276 22.5746L27.4327 30.2809C27.7921 30.7002 28.4234 30.7488 28.8427 30.3894C29.262 30.0299 29.3106 29.3986 28.9512 28.9793L22.3647 21.2947C24.0752 19.5665 25.1315 17.1895 25.1315 14.5658C25.1315 9.28274 20.8488 5 15.5658 5Z"
      fill={fill}
    />
  </svg>
);

export const SearchIconAtom = styled(SearchIcon)`
  transition: ${vars.defaultTransition};
`;

export const BurgerIconAtom: React.FC<IconProps> = ({
  className,
  stroke = vars.coreDarkGrey,
  width = 26,
  height = 16,
  viewBox = '0 0 26 16',
  title,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    <line
      x1="7"
      y1="1"
      x2="25"
      y2="1"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="1"
      y1="8"
      x2="25"
      y2="8"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="7"
      y1="15"
      x2="25"
      y2="15"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ChevronLeftAtom: React.FC<IconProps> = ({
  stroke = 'white',
  width = 9,
  height = 14,
  viewBox = '0 0 9 14',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1L1 7L8 13"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronDownAtom: React.FC<IconProps> = ({
  className,
  stroke = vars.coreDarkGrey,
  width = 9,
  height = 7,
  viewBox = '0 0 9 7',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.5L4.5 5.5L8 1.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StyledChevronDownAtom = styled(ChevronDownAtom)`
  margin-left: ${vars.spacingS};
`;

const ChevronUpAtom: React.FC<IconProps> = ({
  className,
  stroke = vars.coreDarkGrey,
  width = 9,
  height = 7,
  viewBox = '0 0 9 7',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5.5L4.5 1.5L1 5.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StyledChevronUpAtom = styled(ChevronUpAtom)`
  margin-left: ${vars.spacingS};
`;

export const ChevronRightAtom: React.FC<IconProps> = ({
  stroke = vars.emfBlue,
  width = 9,
  height = 14,
  viewBox = '0 0 9 14',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13L8 7L1 1"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MobileMenuButton: React.FC<IconProps> = ({ stroke }) => (
  <svg
    width="24"
    height="14"
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="5"
      y1="1"
      x2="23"
      y2="1"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="1"
      y1="7"
      x2="23"
      y2="7"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="5"
      y1="13"
      x2="23"
      y2="13"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
